/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";
import { Markup } from 'interweave';
import { useTranslation } from "react-i18next";
import contents from './contents.json';

export default function Leadership(){
    const { t } = useTranslation();

    const leaders = {
        lingam:{
            name:"Srinivas Lingam",
            designation: "Country Head - Centrico India",
            id: "lingam",
            profile: '<p>As CEO, <b>Srinivas Lingam (Lingam)</b> heads the Chennai delivery center team for IT Application Development and Support to Core Banking system maintenance activities, sistema di core banking.</p><p>For twenty-three years in the IT field of the banking and financial services world, Lingam loves to create outstanding teams and solutions that respond precisely and profitably to the demands of each client.</p><p>Previously, he worked for Polaris Software and Mphasis (at the time part of Hewlett-Packard) within the Sales Functions, Sales Support, Corporate Planning, Client Account Management and Delivery Management.</p><p>While away from work, he enjoys cooking, solving word puzzles, long drives and listening to music.</p>',
            linkedInUrl:'https://www.linkedin.com/in/srinivaslingam/'
        },
        bharath:{
            name:"Bharathkumar Krishnamachari",
            designation: "Deputy Country Head - Centrico India",
            id: "bharath",
            profile: '<p><b>Bharathkumar Krishnamachari (Bharath)</b> Heads the solutioning for Fabrick (Open Banking Platform & Solutions), PMO and Testing teams at Centrico India. His expertise lies in Delivery Management, Client Management, People Management and Functional Analysis.</p><p>Bharath started his career as a fresher at the then Sella Synergy India Limited and moved through various roles to grow into a Delivery Partner, handling the then Axerve and Fabrick business solutions, in the last 23 years.</p><p>He has led a large team in building innovative payment and wallet solutions for a flagship Digital Banking and Payment Product. He has handled multiple instances of building teams from scratch and takes pride in building strong, self-sustainable teams and leaders who can independently handle deliveries by themselves.</p><p>He is a sportsperson at heart, and the same values also drive him to never give up, be authentic and focus on continuous improvements.</p>',
            linkedInUrl:'https://www.linkedin.com/in/bharathkumar-k-264784b/'
        },
        anamika:{
            name:"Anamika Sinha",
            designation: "Head of People & Culture",
            id: "anamika",
            profile: '<p><b>Anamika Sinha</b>, Head of People & Culture, joined Centrico India in 2021. Prior to that, she was associated with two large IT giants of India, TCS and Cognizant for about 15 years. She has expertise in the areas of Performance Management, Employee Relations, Change Management, System Integration, Workforce Management and Recruitment.</p><p>At Centrico India, her key contribution has been in the implementation of Workday, one of the major transformational initiatives. Mentorship Programs, Individual Development Plan, Employer Branding, Diversity programs and candidate experience programs are a few that have been successfully launched and implemented under her leadership in Centrico India.</p><p>She is highly passionate about the work she does and believes it to be her driving force, bringing out the best in her. Always a trainee at heart, she learns, grows, and contributes to the organization with zeal. Outside of work, she finds bliss in writing.</p>',
            linkedInUrl:'https://www.linkedin.com/in/anamika-sinha-24181037/'
        }
    }

    const [openModal, setOpenModal] = useState(false);
    const [selectedLeader, setSelectedLeader] = useState({});
    const viewProfileModal = (e, leader) =>{
        setOpenModal(!openModal);
        setSelectedLeader(leaders[leader])
    }
    const handleModalClose = () =>{
        setOpenModal(false);
        setSelectedLeader({})
    }

    return(
        <article id="leadership">
                <section className="leadership">
                    <Container>
                        <Row>
                            <Col>
                                <div className="section-highlight">OUR LEADERSHIP TEAM</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div class="section-title">
                                    <h4>Executive Team - Centrico India</h4>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="team-list">
                                    <Row>
                                        {contents.leader.executive.map(item=>(
                                            <Col>
                                                <div className="leader-container">
                                                    <div className={`profile-pic ${item}`}>
                                                        <div className="pic"></div>
                                                    </div>
                                                    <div className="profile-details">
                                                        <div className="name">{t(`aboutus.leaders.executive.${item}.name`)}</div>
                                                        <div className="designation">{t(`aboutus.leaders.executive.${item}.designation`)}</div>
                                                    </div>
                                                    <div className="profile-actions">
                                                        <button className="btn c-button c-gradient" onClick={(e)=>viewProfileModal(e, item)}>{t(`aboutus.leaders.viewprofile`)}</button>
                                                        <div class="linkedin-icon">
                                                            <a href={t(`aboutus.leaders.executive.${item}.linkedInUrl`)} target="_blank" class="icon"></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Modal show={openModal} size="lg" className="profile-modal" keyboard={true} onEscapeKeyDown={handleModalClose} onHide={handleModalClose}>
                    <Modal.Header>
                        <div className="close-btn">
                            <button onClick={handleModalClose}><XLg/></button>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="profile-area">
                            <div className={`profile-pic ${selectedLeader.id}`}></div>
                            <div className="profile-details">
                                <div className="name">{t(`aboutus.leaders.executive.${selectedLeader.id}.name`)}
                                    <div class="linkedin-icon">
                                    <a href={selectedLeader.linkedInUrl} target="_blank" class="icon"></a>
                                    </div>
                                </div>
                                <div className="designation">{t(`aboutus.leaders.executive.${selectedLeader.id}.designation`)}</div>
                            </div>
                        </div>
                        <div className="profile-description">
                            <Markup content={t(`aboutus.leaders.executive.${selectedLeader.id}.profile`)}></Markup>
                        </div>
                    </Modal.Body>
                </Modal>
            </article>
    )
}